import ProjectScopeDocModalModule from './scope-doc-modal.module'

export default ProjectScopeDocModalModule
